// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__li6Y7","title":"Header_title__108AZ","side":"Header_side__tLfge"};